<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="ah-detail-dialog draw-request-page"
        top="4vh"
        append-to-body
        :before-close="() => onClose()"
        @open="onOpen"
    >
        <template slot="title">
            <span v-if="!sno">新增動撥借款</span>
            <span v-else>編輯動撥借款</span>
        </template>

        <div class="detail-row">
            <div class="detail-block">
                <el-form ref="form" :model="form" :rules="rules" label-position="right" label-width="130px" v-loading="isLoading">
                    <el-form-item prop="repaymentWay" label="還款方式" v-show="false">
                        <el-radio-group v-model="form.repaymentWay" @change="onChangeType">
                            <el-radio-button v-if="contrast.repaymentWay !== 2" :label="1"></el-radio-button>
                            <el-radio-button v-if="contrast.repaymentWay !== 1" :label="2"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <!-- <div class="section-title" style="margin-top: 50px;">合約內容</div> -->

                    <el-row :gutter="60">
                        <el-col :sm="9">
                            <div class="info-block">
                                <h3 style="font-size: 15pt; color: #000">{{ contrast.title }}</h3>
                                <template v-if="repaymentWay === 1">
                                    <div style="color: #463cb2; font-weight: bold; font-size: 12pt; margin-bottom: 20px">
                                        <div>循環額度一次還本</div>
                                    </div>
                                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" v-if="repaymentWay === 1">
                                        <tr>
                                            <th>合約額度</th>
                                            <td>
                                                <span v-if="contrast"><Money :v="contrast.repaymentAmount" /></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>利率</th>
                                            <td>
                                                <span v-if="contrast">{{ contrast.repaymentRate }} %</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>還款期限</th>
                                            <td>
                                                <span v-if="contrast">{{ contrast.repaymentPeriods }} 天</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>額度到期日</th>
                                            <td>
                                                <span v-if="contrast">{{ contrast.repaymentEndDate | dateFormater("YYYY / MM / dd") }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <td style="padding: 10px"></td>
                                        </tr>
                                        <tr>
                                            <th>已動撥總額</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="revolvingTotalDrawingAmtTilToday" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>已還款總額</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="revolvingTotalReturnAmtTilToday" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="revolvingTotalDrawingAmtInFuture > 0">
                                            <th>預約動撥總額</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="revolvingTotalDrawingAmtInFuture" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="revolvingTotalReturnAmtInFuture > 0">
                                            <th>預約還款總額</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="revolvingTotalReturnAmtInFuture" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <td style="padding: 10px"></td>
                                        </tr>
                                        <tr>
                                            <th>可用額度</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="revolvingAvailableAmt" style="font-size: 18pt" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                    </table>
                                </template>
                                <template v-if="repaymentWay === 2">
                                    <div style="color: #463cb2; font-weight: bold; font-size: 12pt; margin-bottom: 20px">
                                        <div>平均攤還</div>
                                    </div>
                                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" v-if="repaymentWay === 2">
                                        <tr>
                                            <th>利率</th>
                                            <td>
                                                <span v-if="contrast">{{ contrast.amortizationRate }} %</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>還款期限</th>
                                            <td>
                                                <span v-if="contrast">{{ contrast.amortizationPeriods }}期</span><br />
                                                <span v-if="contrast">{{ contrast.amortizationStartDate | dateFormater("YYYY / MM / dd") }}</span
                                                ><br />至<br />
                                                <span v-if="contrast">{{ contrast.amortizationEndDate | dateFormater("YYYY / MM / dd") }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>還款日</th>
                                            <td>
                                                <span v-if="contrast">每月 {{ contrast.amortizationFixedPaymentDate }} 日</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <td style="padding: 10px"></td>
                                        </tr>
                                        <tr>
                                            <th>合約額度</th>
                                            <td>
                                                <span v-if="contrast"><Money :v="contrast.amortizationAmount" /></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>已動撥總額</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="amortizationDrawingAmtTilToday" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="amortizationDrawingAmtInFuture > 0">
                                            <th>預約動撥總額</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="amortizationDrawingAmtInFuture" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <td style="padding: 10px"></td>
                                        </tr>
                                        <tr>
                                            <th>可用額度</th>
                                            <td>
                                                <span v-if="contrast">
                                                    <Money v-if="!isLoading" :v="amortizationAvailableAmt" style="font-size: 18pt" />
                                                    <span v-if="isLoading">...</span>
                                                </span>
                                            </td>
                                        </tr>
                                    </table>
                                </template>
                            </div>
                        </el-col>
                        <el-col :sm="15">
                            <div class="section-title" style="margin-top: 25px">動撥內容</div>
                            <el-form-item prop="drawdown">
                                <template slot="label"> 補登資料 <ah-tip>用於補登以前已動撥紀錄，此次動撥金額將不存入銀行帳戶。</ah-tip> </template>
                                <el-checkbox v-model="form.isMakeUpRegistration" />
                            </el-form-item>
                            <el-row :gutter="12">
                                <el-col :sm="14">
                                    <el-form-item prop="amount" label="動撥借款金額">
                                        <money-input v-model="form.amount" @input="onAutoFillSummary" />
                                    </el-form-item>
                                </el-col>
                                <el-col :sm="10">
                                    <el-form-item prop="rate" label="貸款利率">
                                        <div class="flex-block">
                                            <money-input v-model="form.rate" :precision="3" suffix="%" />
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="12">
                                <el-col :sm="12">
                                    <el-form-item prop="drawdownDate" label="動撥日期">
                                        <el-date-picker
                                            v-model="form.drawdownDate"
                                            value-format="timestamp"
                                            type="date"
                                            placeholder="選擇日期"
                                            :picker-options="{ disabledDate }"
                                            style="width: 100%"
                                            @change="onAutoFillDate"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :sm="12" v-if="form.repaymentWay === 1">
                                    <el-form-item prop="" label="還款到期日">
                                        <el-input :disabled="true" :value="repaymentDueDate" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item prop="summary" label="動撥摘要">
                                <el-input v-model="form.summary" :maxlength="200" show-word-limit @change="isUserEditSummary = true" />
                            </el-form-item>
                            <el-form-item label="借款戶" v-show="false">
                                <el-input :value="contrast.loanBankName" disabled style="width: 350px" />
                            </el-form-item>
                            <el-form-item v-if="!form.isMakeUpRegistration" prop="depositorBankSno" label="存入銀行帳戶">
                                <ah-el-select-bank-account v-if="!isLoading" v-model="form.depositorBankSno" document-type="loan" hide-borrower cny="TWD" />
                            </el-form-item>
                            <el-form-item prop="note" label="備註">
                                <el-input v-model="form.note" type="textarea" :rows="2" :maxlength="200" show-word-limit />
                            </el-form-item>
                            <div v-if="!form.isMakeUpRegistration">
                                <div class="section-title" style="margin-top: 50px">費用</div>
                                <el-form-item label="信保費">
                                    <div class="flex-block">
                                        <el-form-item prop="feE_CD_AMT">
                                            <money-input v-model="form.feE_CD_AMT" style="width: 150px" @change="onAutoFillDate" />
                                        </el-form-item>
                                        <el-form-item prop="feE_CD_PAY_DAT" :rules="form.feE_CD_AMT ? rules.feE_CD_PAY_DAT : []">
                                            <el-date-picker v-model="form.feE_CD_PAY_DAT" value-format="timestamp" type="date" placeholder="選擇日期" disabled style="width: 150px; margin: 0 10px">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item prop="feE_CD_BNK_SNO" :rules="form.feE_CD_AMT ? rules.feE_CD_BNK_SNO : []">
                                            <ah-el-select-bank-account v-if="!isLoading" v-model="form.feE_CD_BNK_SNO" document-type="loan" hide-borrower :disabled="!form.feE_CD_AMT" cny="TWD" />
                                        </el-form-item>
                                    </div>
                                </el-form-item>
                                <el-form-item label="信貸手續費">
                                    <div class="flex-block">
                                        <el-form-item prop="feE_HAND_AMT">
                                            <money-input v-model="form.feE_HAND_AMT" style="width: 150px" @change="onAutoFillDate" />
                                        </el-form-item>
                                        <el-form-item prop="feE_HAND_PAY_DAT" :rules="form.feE_HAND_AMT ? rules.feE_HAND_PAY_DAT : []">
                                            <el-date-picker v-model="form.feE_HAND_PAY_DAT" value-format="timestamp" type="date" placeholder="選擇日期" disabled style="width: 150px; margin: 0 10px">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item prop="feE_HAND_BNK_SNO" :rules="form.feE_HAND_AMT ? rules.feE_HAND_BNK_SNO : []">
                                            <ah-el-select-bank-account v-if="!isLoading" v-model="form.feE_HAND_BNK_SNO" document-type="loan" hide-borrower :disabled="!form.feE_HAND_AMT" cny="TWD" />
                                        </el-form-item>
                                    </div>
                                </el-form-item>
                                <el-form-item label="匯費">
                                    <div class="flex-block">
                                        <el-form-item prop="reM_FEE_AMT">
                                            <money-input v-model="form.reM_FEE_AMT" style="width: 150px" @change="onAutoFillDate" />
                                        </el-form-item>
                                        <el-form-item prop="reM_FEE_PAY_DAT" :rules="form.reM_FEE_AMT ? rules.reM_FEE_PAY_DAT : []">
                                            <el-date-picker v-model="form.reM_FEE_PAY_DAT" value-format="timestamp" type="date" placeholder="選擇日期" disabled style="width: 150px; margin: 0 10px">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item prop="reM_FEE_BNK_SNO" :rules="form.reM_FEE_AMT ? rules.reM_FEE_BNK_SNO : []">
                                            <ah-el-select-bank-account v-if="!isLoading" v-model="form.reM_FEE_BNK_SNO" document-type="loan" hide-borrower :disabled="!form.reM_FEE_AMT" cny="TWD" />
                                        </el-form-item>
                                    </div>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="footer-actions">
                    <div>
                        <el-button :loading="isLoading" @click="onClose()">取消</el-button>
                        <el-button v-if="!isQR()" type="primary" class="primary-action" :loading="isLoading" @click="onSubmit">
                            <span v-if="!!sno">儲存</span>
                            <span v-else>新增</span>
                        </el-button>
                    </div>
                </div>
            </div>
            <div v-if="!!sno" class="panel-body">
                <div class="ah-container">
                    <div class="data-record">
                        <div v-if="creatorInfo" class="creator">資料建立：{{ creatorInfo }}</div>
                        <div v-if="editorInfo" class="editor">最後編輯：{{ editorInfo }}</div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import moment from 'moment';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';

export default {
    components: { ahElSelectBankAccount },
    props: {
        visible: Boolean,
        sno: Number,
        repaymentWay: {
            type: Number,
            default: null,
        },
        contrast: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isLoading: false,
            datas: [],
            form: {
                isMakeUpRegistration: false,
                loanReceiptSno: undefined,
                repaymentWay: null,
                amount: null,
                rate: null,
                summary: null,
                drawdownDate: null,
                depositorBankSno: null,

                // 信保費
                feE_CD_AMT: 0,
                feE_CD_BNK_SNO: null,
                feE_CD_PAY_DAT: null,
                // 信保手續費
                feE_HAND_AMT: 0,
                feE_HAND_PAY_DAT: null,
                feE_HAND_BNK_SNO: null,
                // 匯費
                reM_FEE_AMT: 0,
                reM_FEE_PAY_DAT: null,
                reM_FEE_BNK_SNO: null,

                note: null,
            },
            rules: {
                repaymentWay: [{ required: true, message: '請輸入欄位' }],
                amount: [{ required: true, message: '請輸入欄位' }],
                rate: [{ required: true, message: '請輸入欄位' }],
                summary: [{ required: true, message: '請輸入欄位' }],
                drawdownDate: [{ required: true, message: '請輸入欄位' }],
                depositorBankSno: [{ required: true, message: '請輸入欄位' }],
                // 信保費
                feE_CD_AMT: [{ required: true, message: '請輸入欄位' }],
                feE_CD_BNK_SNO: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                feE_CD_PAY_DAT: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                // 信保手續費
                feE_HAND_AMT: [{ required: true, message: '請輸入欄位' }],
                feE_HAND_PAY_DAT: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                feE_HAND_BNK_SNO: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                // 匯費
                reM_FEE_AMT: [{ required: true, message: '請輸入欄位' }],
                reM_FEE_PAY_DAT: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                reM_FEE_BNK_SNO: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
            },

            isUserEditSummary: false,

            creator: null,
            createDate: null,
            editor: null,
            editDate: null,
        };
    },
    watch: {
        repaymentWay(newVal, oldVal) {
            if (!this.sno) this.form.repaymentWay = newVal;
        },
    },
    computed: {
        creatorInfo() {
            if (!this.form.crT_NAM || !this.form.crT_DAT) return false;

            return `${this.form.crT_NAM || '--'}, ${moment(this.form.crT_DAT).format('YYYY-MM-DD') || '--'}`;
        },
        editorInfo() {
            if (!this.form.upD_NAM || !this.form.upD_DAT) return false;

            return `${this.form.upD_NAM || '--'}, ${moment(this.form.upD_DAT).format('YYYY-MM-DD') || '--'}`;
        },

        repaymentDueDate() {
            if (this.form.drawdownDate) {
                return moment(this.form.drawdownDate).add(this.contrast.repaymentPeriods, 'day').format('YYYY-MM-DD');
            }
            return '';
        },
        // 循環額度 已動撥總額（含未來）
        revolvingTotalDrawingAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 循環額度 已還款總額（含未來）
        revolvingTotalReturnAmt() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => _.sumBy(o.repaymentList, 'principalAmount'))
                .sum()
                .value();
        },
        // 循環額度 可用餘額
        revolvingAvailableAmt() {
            return this.contrast.repaymentAmount - this.revolvingTotalDrawingAmt + this.revolvingTotalReturnAmt;
        },
        // 循環額度 可用餘額 %
        revolvingAvailablePercent() {
            if (this.revolvingAvailableAmt && this.contrast.repaymentAmount) return Math.round((this.revolvingAvailableAmt / this.detail.repaymentAmount) * 100);
            return 0;
        },
        // 循環額度 已動撥總額（截至今日，不含未來）
        revolvingTotalDrawingAmtTilToday() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .filter((x) => x.drawdownDate <= +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 循環額度 已還款總額（截至今日，不含未來）
        revolvingTotalReturnAmtTilToday() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate <= +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },
        // 循環額度 預約動撥總額（未來）
        revolvingTotalDrawingAmtInFuture() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .filter((x) => x.drawdownDate > +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 循環額度 預約還款總額（未來）
        revolvingTotalReturnAmtInFuture() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 1])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate > +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },
        // 平均攤還可用餘額
        amortizationAvailableAmt() {
            return (
                this.contrast.amortizationAmount
                - _.chain(this.datas)
                    .filter(['repaymentWay', 2])
                    .map((o) => o.amount)
                    .sum()
                    .value()
            );
        },
        // 平均攤還已還款總額（至今日）
        amortizationReturnAmtTilToday() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate <= +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },
        // 平均攤還預還款總額（未來日）
        amortizationReturnAmtInFuture() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .map((o) => _.sumBy(
                    _.filter(o.repaymentList, (x) => x.repaymentDate > +new Date()),
                    'principalAmount',
                ))
                .sum()
                .value();
        },
        // 平均攤還 已動撥總額（至今日）
        amortizationDrawingAmtTilToday() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .filter((x) => x.drawdownDate <= +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
        // 平均攤還 預約動撥總額（未來日）
        amortizationDrawingAmtInFuture() {
            return _.chain(this.datas)
                .filter(['repaymentWay', 2])
                .filter((x) => x.drawdownDate > +new Date())
                .map((o) => o.amount)
                .sum()
                .value();
        },
    },
    methods: {
        async onOpen() {
            this.isLoading = true;
            if (this.sno) {
                await this.fetchData();
            }
            if (!this.sno) {
                this.form.repaymentWay = this.repaymentWay;
                this.onChangeType(this.repaymentWay);
            }
            this.form.loanReceiptSno = this.contrast.sno;
            this.getDrawDownList();
            this.isLoading = false;
        },
        async fetchData() {
            const resp = await this.$api({
                method: 'GET',
                url: 'LoanReceipt/GetLoanReceiptDrawdownDetail',
                params: { sno: this.sno },
            });

            console.log('draw down detail', resp);
            this.form = resp.data.detail;
        },
        async getDrawDownList() {
            const resp = await this.$api({
                method: 'GET',
                url: 'LoanReceipt/GetLoanReceiptDrawdownList',
                params: { LoanReceiptSno: this.contrast.sno, PageSize: 99, PageNum: 1 },
            });
            this.datas = resp.data.items;
        },
        onClose(refresh) {
            this.form = {
                isMakeUpRegistration: false,
                loanReceiptSno: undefined,
                repaymentWay: null,
                amount: null,
                rate: null,
                summary: null,
                drawdownDate: null,
                depositorBankSno: null,

                // 信保費
                feE_CD_AMT: 0,
                feE_CD_BNK_SNO: null,
                feE_CD_PAY_DAT: null,
                // 信貸手續費
                feE_HAND_AMT: 0,
                feE_HAND_PAY_DAT: null,
                feE_HAND_BNK_SNO: null,
                // 匯費
                reM_FEE_AMT: 0,
                reM_FEE_PAY_DAT: null,
                reM_FEE_BNK_SNO: null,
                note: null,
            };
            this.$refs.form.resetFields();
            this.isUserEditSummary = false;
            this.$emit('close', refresh);
        },

        onSubmit() {
            // 如是補登，移除帳戶欄位資料
            if (this.form.isMakeUpRegistration === true) {
                this.form.depositorBankSno = null; // 存入銀行帳戶

                // 信保費歸零
                this.form.feE_CD_AMT = 0;
                this.form.feE_CD_DAT = null;
                this.form.feE_CD_BNK_SNO = null;

                // 信貸手續費歸零
                this.form.feE_HAND_AMT = 0;
                this.form.feE_HAND_DAT = null;
                this.form.feE_HAND_BNK_SNO = null;

                // 匯費歸零
                this.form.reM_FEE_AMT = 0;
                this.form.reM_FEE_DAT = null;
                this.form.reM_FEE_BNK_SNO = null;
            }

            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;
                        if (this.sno) await this.onUpdate();
                        else await this.onCreate();

                        this.$message({
                            showClose: true,
                            message: `已成功${this.sno ? '更新' : '建立'}動撥`,
                            type: 'success',
                        });

                        this.onClose(true);
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        async onCreate() {
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/AddLoanReceiptDrawdown',
                data: this.form,
            });
        },
        async onUpdate() {
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/UpdateLoanReceiptDrawdown',
                data: this.form,
            });
        },

        onChangeType(repaymentWay) {
            if (repaymentWay === 1) {
                // this.form.amount = this.contrast.repaymentAmount;
                this.form.rate = this.contrast.repaymentRate;
            } else {
                // this.form.amount = this.contrast.amortizationAmount;
                this.form.rate = this.contrast.amortizationRate;
            }

            this.onAutoFillSummary();
        },
        onAutoFillSummary() {
            if (!this.isUserEditSummary) {
                const AMT_TEXT = Number(this.form.amount).toLocaleString('en');
                this.form.summary = `${this.contrast.title} 動撥 ${AMT_TEXT}`;
            }
        },
        onAutoFillDate() {
            if (this.form.feE_CD_AMT) this.form.feE_CD_PAY_DAT = this.form.drawdownDate;
            else {
                this.form.feE_CD_PAY_DAT = null;
                this.form.feE_CD_BNK_SNO = null;
            }

            if (this.form.feE_HAND_AMT) this.form.feE_HAND_PAY_DAT = this.form.drawdownDate;
            else {
                this.form.feE_HAND_PAY_DAT = null;
                this.form.feE_HAND_BNK_SNO = null;
            }

            if (this.form.reM_FEE_AMT) this.form.reM_FEE_PAY_DAT = this.form.drawdownDate;
            else {
                this.form.reM_FEE_PAY_DAT = null;
                this.form.reM_FEE_BNK_SNO = null;
            }
        },
        disabledDate(date) {
            if (this.form.repaymentWay === 1) {
                return moment(date).isBefore(moment(this.contrast.approvalDate)) || moment(date).isAfter(moment(this.contrast.repaymentEndDate));
            }
            return moment(date).isBefore(moment(this.contrast.amortizationStartDate)) || moment(date).isAfter(moment(this.contrast.amortizationEndDate));
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.draw-request-page {
    .section-title {
        color: $main-color;
        font-weight: bold;
        font-size: 11pt;
        border-bottom: 1px solid $main-color;
        padding-bottom: 5px;
        margin-bottom: 15px;
    }

    .info-block {
        background-color: #f6f8f8;
        padding: 30px 20px;
        border-radius: 10px;
        margin-top: 10px;
    }

    .el-dialog {
        max-width: 1150px !important;
    }

    .loan-type-card {
        height: 110px;
        width: 130px;
        text-align: right;
        .other-info {
            text-align: left;
            margin-top: 10px;
            font-size: 9pt;
            line-height: 13px;
        }
    }
    .suffix {
        margin-left: 10px;
    }
    .flex-block {
        display: flex;
    }
    .data-record {
        font-size: 10pt;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .button-set {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }

    .footer-actions {
        display: flex;
        justify-content: space-between;
        margin: 25px 0 10px 0;
    }
}
</style>
